import { IStorage } from '../adapter';

class MemoryStorage implements IStorage {
  private storage: Map<string, string> = new Map();

  /**
   * 获取存储的值
   */
  async getItem(key: string): Promise<string | null> {
    try {
      const value = this.storage.get(key);
      return value !== undefined ? value : null;
    } catch (error) {
      console.error('MemoryStorage getItem error:', error);
      return null;
    }
  }

  /**
   * 设置存储的值
   */
  async setItem(key: string, value: unknown): Promise<void> {
    try {
      this.storage.set(key, String(value));
    } catch (error) {
      console.error('MemoryStorage setItem error:', error);
      throw error;
    }
  }

  /**
   * 删除存储的值
   */
  async removeItem(key: string): Promise<void> {
    try {
      this.storage.delete(key);
    } catch (error) {
      console.error('MemoryStorage removeItem error:', error);
      throw error;
    }
  }

  /**
   * 清空所有存储
   */
  async clear(): Promise<void> {
    try {
      this.storage.clear();
    } catch (error) {
      console.error('MemoryStorage clear error:', error);
      throw error;
    }
  }

  /**
   * 根据索引获取键名
   */
  async key(index: number): Promise<string> {
    try {
      const keys = Array.from(this.storage.keys());
      return index >= 0 && index < keys.length ? keys[index] : '';
    } catch (error) {
      console.error('MemoryStorage key error:', error);
      return '';
    }
  }

  /**
   * 获取存储项的数量
   */
  async length(): Promise<number> {
    try {
      return this.storage.size;
    } catch (error) {
      console.error('MemoryStorage length error:', error);
      return 0;
    }
  }

  /**
   * 获取所有存储的键
   */
  getKeys(): string[] {
    return Array.from(this.storage.keys());
  }

  /**
   * 获取所有存储的键值对
   */
  getAll(): Record<string, string> {
    const result: Record<string, string> = {};
    this.storage.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }

  /**
   * 检查是否包含某个键
   */
  hasKey(key: string): boolean {
    return this.storage.has(key);
  }
}

export default new MemoryStorage();
